module.exports = __webpack_public_path__ + "assets/img/gar8-7.329924d5.jpg";